import {useTemplate} from 'Event/TemplateProvider'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import styled from 'styled-components'
import {onChangeCheckedHandler} from 'lib/dom'
import React from 'react'
import {EnabledSwitch} from 'lib/ui/form/Switch'

export default function ToggleBackgroundsSwitch() {
  const {zoomBackgrounds} = useTemplate()
  const save = useSaveTemplate()
  const toggle = (isEnabled: boolean) => {
    save({
      zoomBackgrounds: {
        isEnabled,
      },
    })
  }

  return (
    <StyledEnabledSwitch
      checked={zoomBackgrounds.isEnabled}
      onChange={onChangeCheckedHandler(toggle)}
      aria-label="toggle zoom backgrounds"
    />
  )
}

const StyledEnabledSwitch = styled(EnabledSwitch)`
  margin-bottom: 0;
`
